// extracted by mini-css-extract-plugin
export default {"container":"emailVerify_container__eNLEP","error":"emailVerify_error__Q-xxN"};